if (!customElements.get('product-model')) {
  customElements.define(
    'product-model',
    class ProductModel extends HTMLElement {
      constructor() {
        super();

        this.poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!this.poster) return;

        const posterButton = this.poster.querySelector('[data-poster-button]');
        if (posterButton) {
          // When the poster is clicked, load the video into fixed container
          posterButton.addEventListener('click', () => this.loadContent());

          // Prevent any accidental autoplay on scroll items
          this.removeAttribute('playing');
          this.removeAttribute('loop');
          this.removeAttribute('autoplay');
        }

        // Lazy initialize XR + model UI only when visible
        this.observeVisibility?.();
      }

      loadContent() {
        // Only act if this is *not* the fixed media
        const isFixed =
          this.hasAttribute('fixed_media') &&
          (this.getAttribute('fixed_media') === 'true' || this.getAttribute('fixed_media') === true);

        if (!isFixed) {
          // This is a scrolling media thumbnail — clone video template into fixed area
          const template = this.querySelector('template');
          if (!template) return;

          const fixedContainer =
            document.querySelector('.media-fixed') ||
            document.querySelector('.main-product-featuredmedia .media-fixed');

          if (!fixedContainer) return;

          // Stop all other site videos
          if (window.stopAllSiteVideos) window.stopAllSiteVideos();

          // Clear the fixed container and append the actual video
          fixedContainer.innerHTML = '';
          const videoElement = template.content.firstElementChild.cloneNode(true);
          fixedContainer.appendChild(videoElement);

          // Start playback if possible
          if (videoElement.tagName === 'VIDEO') {
            videoElement.muted = true;
            videoElement.playsInline = true;
            videoElement.play().catch(() => {});
          } else if (videoElement.tagName === 'IFRAME') {
            // Add autoplay params for YouTube/Vimeo
            const src = videoElement.src;
            if (src && !src.includes('autoplay=1')) {
              const sep = src.includes('?') ? '&' : '?';
              videoElement.src = src + sep + 'autoplay=1&muted=1';
            }
          }

          // Keep poster visible in scroll list
          return;
        }

        // If it's actually the fixed media, fall back to normal loading
        if (!this.getAttribute('loaded')) {
          window.stopAllSiteVideos?.();
          this.removePoster();

          const content = document.createElement('div');
          content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

          this.setAttribute('loaded', true);
          const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
          deferredElement.focus?.();
        }

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }

      removePoster() {
        const posterContainer = this;
        if (posterContainer) {
          posterContainer.style.transition = 'opacity 0.5s ease-in-out';
          const elementsToRemove = [
            posterContainer.querySelector('img'),
            posterContainer.querySelector('[data-poster-button]'),
          ].filter(Boolean);

          elementsToRemove.forEach((element) => {
            element.classList.add('poster-fade-out');
            setTimeout(() => element.remove(), 500);
          });
          posterContainer.querySelector('button')?.classList.add('hidden');
        }
      }

      setupModelViewerUI(errors) {
        if (errors) return;

        const modelViewer = this.querySelector('model-viewer');
        let observer = null;

        const tryInit = () => {
          const modelViewer = this.querySelector('model-viewer');
          if (modelViewer) {
            this.modelViewerUI = new Shopify.ModelViewerUI(modelViewer);
            if (observer) observer.disconnect();
          }
        };

        tryInit();

        observer = new MutationObserver(tryInit);
        observer.observe(this, { childList: true, subtree: true });
      }
    }
  );
}
